import { render, staticRenderFns } from "./RoleEditor.vue?vue&type=template&id=276221f8&"
import script from "./RoleEditor.vue?vue&type=script&lang=ts&"
export * from "./RoleEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports